import { Unit } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type BrokeredOrderLineItemCreateInput = {
  itemId: string;
  quantity: number;
  unit: Unit;
  notes?: string | null;
};

export const brokeredOrderCreateAtom = createMutationAtomFactory(
  'brokerage.brokeredOrderCreate',
  (params: {
    orderNumber: string;
    notes?: string | null;
    lineItems?: BrokeredOrderLineItemCreateInput[];
  }) => ({
    tradeBrokeredOrderCreate: {
      __args: {
        input: {
          orderNumber: params.orderNumber,
          notes: params.notes,
          lineItems: params.lineItems,
        },
      },
      id: true,
      orderNumber: true,
      status: true,
      lineItems: {
        id: true,
        itemId: true,
        quantity: true,
        unit: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
